import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';

import { PickerModule } from '../picker/picker.module';
import { MultiPickerComponent } from './multi-picker.component';

@NgModule({
    imports: [
        CommonModule,
        MatChipsModule,
        MatIconModule,
        PickerModule,
        ReactiveFormsModule,
        MatChipsModule
    ],
    declarations: [
        MultiPickerComponent
    ],
    exports: [
        MultiPickerComponent
    ]
})
export class MultiPickerModule {
}
